import React from "react";
import { cn } from "../../lib/utils";

const Card = ({ className, children, hover = false }) => (
  <div
    className={cn(
      "rounded-xl border border-zinc-800 bg-zinc-950/50 text-zinc-100 shadow-sm backdrop-blur-xl transition-all duration-300",
      hover &&
        "hover:border-zinc-700 hover:shadow-xl hover:shadow-blue-500/10 hover:-translate-y-1",
      className
    )}
  >
    {children}
  </div>
);

export default Card;

